import { participantService } from "../service";
import {
  setParticipantDetailsLoading,
  setParticipantDetailsData,
  setParticipantDetailsError,
} from "../slice/participantDetailsSlice";

const getParticipantDetailsAsync =
  (company_id, participant_id, t) => async (dispatch) => {
    dispatch(setParticipantDetailsLoading())
    try {
      const response = await participantService.getParticipantDetails(
        company_id,
        participant_id
      );

      if (response?.data?.error || response?.data?.Error) {
        dispatch(setParticipantDetailsError(response));
        dispatch(setParticipantDetailsData({}));
       // toast.error(t(response?.data?.error?.error_code), { toastId: 1 });
      } else {
        dispatch(setParticipantDetailsData(response?.data));
        dispatch(setParticipantDetailsError({}));
      }
    } catch (error) {
      dispatch(setParticipantDetailsError(error));
    }
  };

export const ParticipantDetailsAction = {
  getParticipantDetailsAsync,
};
